<button
    class="container"
    [class.small]="sizeSig() === 'small'"
    [class.medium]="sizeSig() === 'medium'"
    [class.large]="sizeSig() === 'large'"
    [class.disabled]="disabledSig() || loadingSig()"
    [class.plain]="variantSig() === 'plain'"
    [class.success]="variantSig() === 'success'"
    [class.secondary]="variantSig() === 'secondary'"
    [class.round]="variantSig() === 'round'"
    [class.colored]="colorSig() === 'primary'"
    [class.link]="variantSig() === 'link'"
    [class.light]="variantSig() === 'light'"
    [class.white]="variantSig() === 'white'"
    [class.min-height-disabled]="minHeightDisabledSig()"
    [attr.type]="typeSig()"
    [disabled]="disabledSig() || loadingSig()"
    (click)="handleClick($event)"

>
    <div class="text">
      @if (!loadingSig()) {
        <ng-content select="[cta-prefix]"></ng-content>
        <ng-content select="[cta-label]"></ng-content>
        <ng-content select="[cta-postfix]"></ng-content>
      } @else {
        <span class="spinner">
          <svg width="20" height="20" viewBox="0 0 50 50">
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-dasharray="31.415, 31.415"
              transform="rotate(0 25 25)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </span>
      }
    </div>
</button>
